import PropTypes from "prop-types"
import React from "react"
import { connect, useSelector } from "react-redux"
import withRouter from "../Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"
import { ICONS } from "../../constants/icons"
import { getUserAvatarUrl } from "../../helpers/userAvatar"
import { getUserFullName } from "../../helpers/userDisplay"

const Sidebar = props => {
  const [menuOpen, setMenuOpen] = React.useState(false)
  const [avatarFailed, setAvatarFailed] = React.useState(false)
  const currentUser = useSelector(state => state.auth.currentUser || null)
  const profileRef = React.useRef(null)
  const avatarUrl = getUserAvatarUrl(currentUser)

  React.useEffect(() => {
    setAvatarFailed(false)
  }, [avatarUrl])

  function tToggle() {
    var body = document.body
    var windowSize = document.documentElement.clientWidth

    if (windowSize < 992) {
      // Below 992px: only toggle sidebar-enable, never collapse
      body.classList.toggle("sidebar-enable")
    } else {
      // Above 992px: toggle collapsed state
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
      body.getAttribute("data-sidebar-size") === "sm" && windowSize > 991
        ? body.setAttribute("data-sidebar-size", "lg")
        : body.setAttribute("data-sidebar-size", "sm")
    }
  }

  function closeSidebarOnClickOutside(e) {
    var windowSize = document.documentElement.clientWidth
    var body = document.body
    var sidebar = document.querySelector(".vertical-menu")

    if (windowSize < 992 && body.classList.contains("sidebar-enable")) {
      if (
        !sidebar.contains(e.target) &&
        !e.target.closest(".vertical-menu-btn")
      ) {
        body.classList.remove("sidebar-enable")
      }
    }
  }

  function handleResize() {
    var windowSize = document.documentElement.clientWidth
    var body = document.body

    // When going from above 992px to below, ensure sidebar is not collapsed
    if (windowSize < 992) {
      body.removeAttribute("data-sidebar-size")
      body.classList.remove("vertical-collpsed")
    }
  }

  React.useEffect(() => {
    document.addEventListener("click", closeSidebarOnClickOutside)
    window.addEventListener("resize", handleResize)
    return () => {
      document.removeEventListener("click", closeSidebarOnClickOutside)
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  React.useEffect(() => {
    if (!menuOpen) return
    const handleClick = e => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setMenuOpen(false)
      }
    }
    const handleKey = e => {
      if (e.key === "Escape") setMenuOpen(false)
    }
    document.addEventListener("mousedown", handleClick)
    document.addEventListener("keydown", handleKey)
    return () => {
      document.removeEventListener("mousedown", handleClick)
      document.removeEventListener("keydown", handleKey)
    }
  }, [menuOpen])

  const displayName = getUserFullName(currentUser)
  const initials = `${currentUser?.first_name?.charAt(0) || ""}${
    currentUser?.last_name?.charAt(0) || ""
  }`.toUpperCase()

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="sidebar-header">
          <div className="sidebar-header__logo">AMOK.EARTH</div>
          <button
            onClick={() => {
              tToggle()
            }}
            type="button"
            className="sidebar-header__toggle-btn"
            aria-label="Toggle sidebar"
          >
            <img
              src={ICONS.sidebarLeft}
              alt=""
              className="sidebar-header__toggle-icon"
            />
          </button>
        </div>
        <div className="sidebar-menu-scroll">
          <SidebarContent />
        </div>
        <div className="sidebar-profile-wrapper">
          <div className="sidebar-profile" ref={profileRef}>
            <button
              type="button"
              className="sidebar-profile__card"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Open profile menu"
              aria-expanded={menuOpen}
            >
              <div className="sidebar-profile__avatar-wrapper">
                <div
                  className="sidebar-profile__avatar"
                  style={{ background: "#E7E7EA" }}
                >
                  {avatarUrl && !avatarFailed ? (
                    <img
                      src={avatarUrl}
                      alt={displayName || "User"}
                      onError={() => setAvatarFailed(true)}
                    />
                  ) : (
                    initials || "?"
                  )}
                </div>
                <div className="sidebar-profile__status" />
              </div>
              <div className="sidebar-profile__info">
                <div className="sidebar-profile__name">
                  {displayName || "User"}
                </div>
                <div className="sidebar-profile__status-row">
                  <span className="sidebar-profile__status-text">Online</span>
                  <img
                    src={ICONS.chevronSidebar}
                    alt=""
                    className="sidebar-profile__status-chevron"
                  />
                </div>
              </div>
              <span className="sidebar-profile__settings" aria-hidden="true">
                <i className="uil uil-setting" />
              </span>
            </button>
            {menuOpen && (
              <div className="sidebar-profile__menu">
                <button
                  type="button"
                  className="sidebar-profile__menu-item"
                  onClick={() => {
                    setMenuOpen(false)
                    if (currentUser?.id) {
                      props.router.navigate(`/profile/${currentUser.id}`)
                    }
                  }}
                >
                  <i className="uil uil-user-circle sidebar-profile__menu-icon" />
                  <span>My Profile</span>
                </button>
                <button
                  type="button"
                  className="sidebar-profile__menu-item"
                  onClick={() => {
                    setMenuOpen(false)
                    props.router.navigate("/logout")
                  }}
                >
                  <i className="uil uil-sign-out-alt sidebar-profile__menu-icon" />
                  <span>Logout</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {},
)(withRouter(withTranslation()(Sidebar)))
